import React from 'react';
import { Routes, Route,Link } from "react-router-dom";
import Layout from "./Layout";
import HomePage from "./HomePage";
import Privacy from "./Privacy";
import ServiceTerms from "./ServiceTerms";

function NoMatch() {
    return (
      <div style={{paddingTop: "100px", textAlign: "center"}}>
        <h2>Nothing to see here!</h2>
        <p>
          <Link to="/">Go to the home page</Link>
        </p>
      </div>
    );
}

function App() {
    
    return (
        <Routes>
        <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="privacy-overview" element={<Privacy />} />
            <Route path="service-terms" element={<ServiceTerms />} />

            {/* Using path="*"" means "match anything", so this route
                acts like a catch-all for URLs that we don't have explicit
                routes for. */}
            <Route path="*" element={<NoMatch />} />
        </Route>
        </Routes>        
    );
}

export default App;
